module.exports = __webpack_public_path__ + "img/img_1.22d17f41.png";